import './FilePreviewModal.scss';

export { default } from './FilePreviewModal';
